"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ViewWorkSection_1 = __importDefault(require("@Components/ViewWork/ViewWorkSection"));
const WriterCard_1 = __importDefault(require("@Components/ViewWork/WriterCard"));
const react_1 = __importDefault(require("react"));
const navigation_1 = __importDefault(require("@App/navigation"));
const EditButton_1 = require("@Components/ViewWork/EditButton");
const WritersSection = (props) => {
    const generateWritersEditLink = () => {
        if (!props.rightsholderId) {
            return navigation_1.default.home.root();
        }
        switch (props.workType) {
            case 'bulk':
                return navigation_1.default.rightholder.createWork.bulk.edit.writers(props.rightsholderId);
            case 'create-form':
                return navigation_1.default.rightholder.createWork.form.writers(props.rightsholderId);
            case 'create-wizard':
                return navigation_1.default.rightholder.createWork.wizard.writers(props.rightsholderId);
            case 'draft':
                return navigation_1.default.rightholder.registrationDrafts.writers(props.rightsholderId, props.workType, props.workId);
            default:
                if (!props.workType) {
                    return navigation_1.default.home.root();
                }
                else {
                    return navigation_1.default.rightholder.catalog.workEdit.writers(props.rightsholderId, props.workType, props.workId);
                }
        }
    };
    const writersEditLink = generateWritersEditLink();
    return (react_1.default.createElement(ViewWorkSection_1.default, { valid: props.editing !== undefined ? !props.writerErrors : undefined, icon: 'writers', title: 'Writers', count: props.writers.length, rightData: react_1.default.createElement(react_1.default.Fragment, null, props.editing && (react_1.default.createElement(EditButton_1.EditButton, { linkTo: writersEditLink, workType: props.workType, wizardFlowIndex: 2 }))) },
        react_1.default.createElement(WriterCard_1.default, { writers: props.writers, errors: props.writerErrors })));
};
exports.default = WritersSection;
